import React from 'react';
import { Typography } from '@mui/material';
import config from '@configFile';
import { useGetDealSummary } from '@hooks/useGetDealSummary';
import { getPostPrice, getProductLink } from '@utils/index';
import MonetizingLink from '@components/MonetizingLink';
import { AdminActionsByASIN } from '@components/AdminActions';

const PriceComponent = ({ ASIN }: { ASIN: string }) => {
  const tag = config.AFFILIATE_TAGS.HAUL;
  const { data: dealSummary, isLoading } = useGetDealSummary(ASIN);
  const link = getProductLink(ASIN, tag);
  if (!dealSummary && isLoading) {
    return <Typography component="span">Loading...</Typography>;
  }

  const showUnavailable =
    (!dealSummary && !isLoading) || !!dealSummary?.isExpired;

  return (
    <Typography component="span">
      <MonetizingLink
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        tag={tag}
        clickType="deal-post-card-coupon-discount"
        underline="hover"
        sx={{
          fontWeight: 'bold',
          color: showUnavailable ? '#ec0001' : 'green'
        }}
      >
        {showUnavailable
          ? ' ❌ unavailable for deal price - click to see at Amazon.'
          : `✅ available for ${getPostPrice(dealSummary, false)}.`}
      </MonetizingLink>
      <AdminActionsByASIN ASIN={ASIN} />
    </Typography>
  );
};

export default PriceComponent;
